import { AssignImport } from './Import'
const { RoutesMap, AssignSubjectTeacherList, AddAssignSubjectTeacher, UpdateAssignSubjectTeacher, AssignCourseSubjectList, AddAssignCourseSubject, UpdateAssignCourseSubject } = AssignImport

const AssignRoute = () => {
    return [
        {
            path: RoutesMap.ASSIGN_SUBJECT_TEACHER_LIST.path,
            element: <AssignSubjectTeacherList />
        },
        {
            path: RoutesMap.ADD_ASSIGN_SUBJECT_TEACHER.path,
            element: <AddAssignSubjectTeacher />
        },
        {
            path: RoutesMap.UPDATE_ASSIGN_SUBJECT_TEACHER.path,
            element: <UpdateAssignSubjectTeacher />
        },
        {
            path: RoutesMap.ASSIGN_COURSE_SUBJECT_LIST.path,
            element: <AssignCourseSubjectList />
        },
        {
            path: RoutesMap.ADD_ASSIGN_COURSE_SUBJECT.path,
            element: <AddAssignCourseSubject />
        },
        {
            path: RoutesMap.UPDATE_ASSIGN_COURSE_SUBJECT.path,
            element: <UpdateAssignCourseSubject />
        },
    ]
}

export default AssignRoute
